/* "Load more" on collection pages. The markup comes from snippets/pagination.liquid, which only prints it on
   the first page of a collection that has more pages. Each click fetches the next page and adds its products
   to the grid. The numbered pagination stays in the page for visitors without JavaScript and for search
   engines; it is hidden while this element is active. If a fetch fails, the visitor is sent to the next page
   the ordinary way. */
if (!customElements.get('delune-load-more')) {
  customElements.define(
    'delune-load-more',
    class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-button]');
        this.count = this.querySelector('[data-count]');
        this.bar = this.querySelector('[data-bar]');
        this.grid = document.getElementById('product-grid');
        this.next = this.dataset.next;
        this.shown = parseInt(this.dataset.shown, 10) || 0;
        this.total = parseInt(this.dataset.total, 10) || 0;

        if (!this.button || !this.grid || !this.next) return;

        this.label = this.button.textContent;
        this.button.addEventListener('click', () => this.load());
        this.hidden = false;
      }

      load() {
        if (this.loading || !this.next) return;
        this.loading = true;
        this.button.disabled = true;
        this.button.textContent = this.button.dataset.loading || 'Loading…';

        fetch(this.next)
          .then((response) => {
            if (!response.ok) throw new Error(response.status);
            return response.text();
          })
          .then((text) => {
            const page = new DOMParser().parseFromString(text, 'text/html');
            // Products only: editorial tiles are placed per page and would repeat
            const items = [...page.querySelectorAll('#product-grid > li.grid__item')].filter(
              (item) => !item.classList.contains('editorial-grid-card')
            );
            // Sold-out products are printed after the ones that can be bought (the grid section does this for
            // each page), so this page's buyable products go in ahead of the first sold-out card already here
            const firstSoldOut = this.grid.querySelector(':scope > .delune-sold-out-last');
            let first = null;

            items.forEach((item) => {
              // The reviews app takes each card's rating from data set by the card's inline script, and scripts
              // in fetched HTML do not run, so run them before the card goes in
              item.querySelectorAll('script').forEach((inert) => {
                const live = document.createElement('script');
                live.textContent = inert.textContent;
                document.head.appendChild(live).remove();
              });

              item.classList.remove('scroll-trigger', 'animate--slide-in');
              const card = document.importNode(item, true);
              if (firstSoldOut && !card.classList.contains('delune-sold-out-last')) {
                this.grid.insertBefore(card, firstSoldOut);
              } else {
                this.grid.appendChild(card);
              }
              if (!first) first = card;
            });

            const nextLink = page.querySelector('[data-next-page]');
            this.next = nextLink ? nextLink.getAttribute('href') : '';
            this.shown = Math.min(this.total, this.shown + items.length);
            this.update();

            // Keyboard and screen-reader users continue from the first new product
            const link = first && first.querySelector('a[href]');
            if (link) link.focus({ preventScroll: true });
          })
          .catch(() => {
            window.location.href = this.next;
          })
          .finally(() => {
            this.loading = false;
            if (this.button.isConnected) {
              this.button.disabled = false;
              this.button.textContent = this.label;
            }
          });
      }

      update() {
        if (this.count) this.count.textContent = (this.button.dataset.showing || 'Showing __shown__ of __total__').replace('__shown__', this.shown).replace('__total__', this.total);
        if (this.bar && this.total) this.bar.style.width = `${Math.round((this.shown / this.total) * 100)}%`;
        if (!this.next) this.button.remove();
      }
    }
  );
}
